import BaseRepository from '@/api/BaseRepository';
import Project from '@/models/Project';
import Customer from '@/models/Customer';

export default class ProjectRepository extends BaseRepository {

    private projectRoute = 'project';

    public async getAllProjects(customer: Customer): Promise<any> {
        return this.axiosClient.get(`${this.projectRoute}?customer=${customer.id}`);
    }

    /*
    * public async getAllProjects(customer: Customer, page: number = 1, limit: number = 10): Promise<any> {
  return this.axiosClient.get(`${this.projectRoute}?customer=${customer.id}&page=${page}&limit=${limit}`);
}
* */

    public async getProject(projectId: string): Promise<any> {
        return this.axiosClient.get(`${this.projectRoute}/${projectId}`);
    }

    public async createProject(project: Project, customer: Customer): Promise<any> {
        try {
            const payload = {
                name: project.name,
                customer: customer.id,
                anfrageNr: project.anfrageNr,
                angebotsNr: project.angebotsNr
            };
            return await this.axiosClient.post(`${this.projectRoute}`, payload);
        } catch (error) {
            console.error('Axios error in createProject:', error);
            // throw new Error(error);
            throw error;
        }
    }

    public async updateProject(project: Project): Promise<any> {
        const payload = {
            name: project.name,
            anfrageNr: project.anfrageNr,
            angebotsNr: project.angebotsNr
        };
        return this.axiosClient.patch(`${this.projectRoute}/${project.id}`, payload);
    }

    public async deleteProject(projectId: string): Promise<any> {
        return this.axiosClient.delete(`${this.projectRoute}/${projectId}`);
    }

    public getExcelPerformanceTable(projectId: string, revisionId: string): Promise<any> {
        return this.axiosClient.get(`${this.projectRoute}/${projectId}/performanceTable?revision=${revisionId}`, { responseType: 'arraybuffer' });
    }

    public getExcelPriceTable(projectId: string, revisionId: string): Promise<any> {
        return this.axiosClient.get(`${this.projectRoute}/${projectId}/priceTable?revision=${revisionId}`, { responseType: 'arraybuffer' });
    }

    public deleteAllActuators(projectId: string): Promise<any> {
        return this.axiosClient.delete(`${this.projectRoute}/deleteAllActuators/${projectId}`);
    }

    public getTotalProjectsAmount(): Promise<number> {
        return this.axiosClient.get(`${this.projectRoute}/total-projects-amount`);
    }

    /** Returns actuator label counts per year: { '2023': [...], '2024': [...], '2025': [...] } */
    public getActuatorLabelCounts(): Promise<Record<string, Array<{ label: string; count: number }>>> {
        return this.axiosClient.get(`${this.projectRoute}/actuator-label-counts`);
    }
}
